import $ from 'jquery';
const axios = require('axios');
$(document).ready(function() {
    const page = $('#google-customer-search');
    if (page.length > 0) {

        const result = $('.resultSearch');
        const swiperWrapper = $('.swiper-wrapper');
        const resultHTML = {
            items: '',
            paginate: '',
            numResult: '',
            infoGoogle: '',
        }
        let data = {
            url_redirect: '',
            result_search: '',
            search: '',
            info_search: '',
            pagination: 0,
            pagination_current: 1,
            url_blank_search: ''
        }
        let API_KEY_GOOGLE = 'AIzaSyB-mMtnbdbVLRnZFOdrjN-nNWEx0qMo53Y';
        let CX = '4a2ad14355e18f845';
        const breadcrumb = async(link) => {
            let breadcrumb = link.split("?")[0].replace('https://www.kaat.jp/', "").split("/");
            let span = '';
            for (const items in breadcrumb) {
                span += `<span> › ${breadcrumb[items]}</span>`;
            }
            return span;
        }
        const googleCustomSearch = async() => {
            var params = {
                key: API_KEY_GOOGLE,
                cx: CX,
                num: 10,
                start: (data.pagination_current - 1) * 10 + 1,
                q: data.search.nodeValue
            }
            await axios.get('https://www.googleapis.com/customsearch/v1', {
                params: params
            }).then(response => {
                data.result_search = response.data;
                data.info_search = 'About ' + response.data.searchInformation.totalResults + ' results (' + response.data.searchInformation.formattedSearchTime + ' seconds)';
                data.pagination = ~~(response.data.searchInformation.totalResults / 10);
                var residual = response.data.searchInformation.totalResults % 10;
                if (residual > 0) {
                    data.pagination = data.pagination + 1;
                }
                if (data.pagination > 10) {
                    data.pagination = 10;
                }
            }).catch(error => {
                data.result_search = '';
                data.info_search = '';
                data.pagination = 0;
            })
            data.url_blank_search = `https://www.google.com/search?client=ms-google-coop&q=${data.search.nodeValue}&cx=${CX}&safe=active&ssui=on`;
        }
        const paginate = async() => {
            let paginate = `<ul class="pagination">`;
            for (let page = 1; page <= data.pagination; page++) {
                if (data.pagination_current == page) {
                    paginate += `<li><a class="active">${page}</a></li>`;
                } else {
                    paginate += `<li><a class="page" data-page="${page}">${page}</a></li>`;
                }
            }
            paginate += `</ul>`;
            return paginate;
        }
        $(document).on('click', '.page', async function() {
            data.pagination_current = $(this).data('page');
            await showData();
        })
        const numResult = async() => {
            return `<p class="numResult">${ data.info_search}</p>`;
        }
        const infoGoogle = async() => {
            return `<div class="infoGoogle">
        <a href="${new URL(data.url_blank_search).href}"
        target="_blank" class="findMore">Search
        <span class="keyWord"> ${data.search.nodeValue}</span> on Google</a>
        <a href="https://cse.google.com/?ref=b&amp;hl=en" class="brand"><img src="/assets/img/common/branding.png" alt="google"></a>
       </div>`;
        }
        const renderItem = async(result_search) => {
            let renderHTML = '';
            let item = '';
            for (const items in result_search) {
                item = result_search[items];
                if (typeof item.pagemap.cse_image !== 'undefined') {
                    renderHTML +=
                        `<div class="blockItem">
          <a href="${item.link}"
              class="ttl">${item.title}</a>
          <p class="urlTop">
            <span>${(typeof item.pagemap.metatags[0]['og:site_name']) !== 'undefined' ? item.pagemap.metatags[0]['og:site_name'] : '' }</span>
            ${await breadcrumb(item.link)}
          </p>
          <div class="result">
            <a href="${item.link}" class="img">
            <img src="${ (item.pagemap.cse_image[0].src) ? item.pagemap.cse_image[0].src : '' }" alt=""></a>
                <p class="txt">${item.snippet}</p>
          </div>
          </div>`;
                }
            }
            return renderHTML;
        }
        const showData = async() => {
            await googleCustomSearch(data.pagination_current);
            resultHTML.items = await renderItem(data.result_search.items);
            resultHTML.infoGoogle = await infoGoogle();
            resultHTML.numResult = await numResult();
            resultHTML.paginate = await paginate();
            result.html(`${ resultHTML.numResult} ${resultHTML.items} ${resultHTML.paginate} ${resultHTML.infoGoogle}`);
        }
        const loadDataSearch = async() => {
            let search = $('.searchInput > input').val();
            if (search !== '') {
                data.search = document.createTextNode(search);
                await showData();
            } else {
                result.html('');
            }
        }
        $(document).on('submit', '.formSearch', async function(event) {
            event.preventDefault();
            await loadDataSearch();
        });
        let pageSearchResult = $('.search-result-form');
        window.onload = async function() {
            if (pageSearchResult.length > 0) {
                await loadDataSearch();
            }
        }
    }
    $(document).on("keypress", ".searchBox .search #search", function(event) {
        if (event.which == 13) {
            let url = $(this).data('url') + `?search=${$(this).val()}`;
            window.location.href = url;
        }
    });
});
